const cibTelegramSign = require('./cib-telegram-sign')
const cibVkSign = require('./cib-vk-sign')
const logo = require('./logo')
const sygnet = require('./sygnet')
const cibPdf = require('./cib-pdf')
const cibFolderStorage = require('./cib-folder-storage')
const cibBitrix24 = require('./cib-bitrix24')

exports.cibTelegramSign = cibTelegramSign.cibTelegramSign
exports.cibVkSign = cibVkSign.cibVkSign
exports.logo = logo.logo
exports.sygnet = sygnet.sygnet
exports.cibPdf = cibPdf.cibPdf
exports.cibFolderStorage = cibFolderStorage.cibFolderStorage
exports.cibBitrix24 = cibBitrix24.cibBitrix24
